export default Object.freeze({
  UK: 'INSTANCE_UK',
  ES: 'INSTANCE_ES',
  PT: 'INSTANCE_PT',
  IT: 'INSTANCE_IT',
  FR: 'INSTANCE_FR',
  CH: 'INSTANCE_CR',
  US: 'INSTANCE_US',
  CA: 'INSTANCE_CA',
  GLOBAL: 'INSTANCE_GLOBAL',
});
